import { GridWrapper } from "../wrapper";
import { styled } from "@mui/material/styles";

export const GridGeneric = styled(GridWrapper)(() => ({
    display: 'flex',
    justifyContent: 'center'

}));